import { render } from "./private.vue?vue&type=template&id=7272bf55"
import script from "./private.vue?vue&type=script&lang=js"
export * from "./private.vue?vue&type=script&lang=js"

import exportComponent from "D:\\cm_zhitu\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__